import { Button } from "@/components/UI/Button";
import {
  actionsConfigOP,
  getEnumKeyByEnumValue,
  IActionObj,
} from "@/components/widgets/tradeActionSummary/helper/actionButtonsHelper";
import {
  getButtonSize,
  onNodeCollapseChangeAllSettingsToFalse,
} from "@/components/widgets/tradeActionSummary/helper/actionSummaryHelper";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import {
  editPanelStoreAction,
  IEditPanelMessage,
} from "@/store/tradeDataStoreACTIONS";
import { useAuth0 } from "@auth0/auth0-react";
import { findThisTradeSettings } from "./SelectPanelHelper";
import { selectPanelProps } from "./SelectPanelIndex";
import tradeSettingsStore from "@/store/tradeSettingsStore";
import useTableUIStore from "@/store/tableUIStore";
import { useEffect, useMemo, useState } from "react";

const MainButtonActionSelectPanel = (props: selectPanelProps) => {
  const {
    data,
    expandedRowsContext,
    setExpandedRowsContext,
    setExpandedRowsContextMostRecentlyUpdated,
    // counterpartiesList,
    generateOutgoingTradeMessage,
  } = props;
  const { getAccessTokenSilently } = useAuth0();

  const fontSize = useTableUIStore((state) => state.fontSize);
  const dynamicButtonSize = useMemo(
    () => getButtonSize(fontSize, "sm"),
    [fontSize],
  );

  // --- Trade Settings - from store.
  const allTradeSettings = tradeSettingsStore(
    (state) => state.tradeSettingsData,
  );
  const [thisTradeSettings, setThisTradeSettings] = useState(
    findThisTradeSettings({ esid: data.esid }),
  );
  useEffect(() => {
    setThisTradeSettings(findThisTradeSettings({ esid: data.esid }));
  }, [allTradeSettings]);
  // --- End Trade Settings.

  // USED when the user is updating the panel from the edit function.
  // LQC-655: send the same per-CP payload shape used by the new-trade POST.
  // generateOutgoingTradeMessage already walks each CP with resolveSettingForCP,
  // so per-CP overrides apply and un-overridden fields fall back to the
  // trade-level value hydrated by the GET /Trade/Execution/Edit/Settings call.
  function updatePanelAction() {
    if (!thisTradeSettings) {
      return;
    }
    const outgoingMessage = generateOutgoingTradeMessage(
      data.esid,
      data.notationES,
    ) as IEditPanelMessage | undefined;
    if (!outgoingMessage) {
      return;
    }
    editPanelStoreAction({
      getAccessTokenSilently: getAccessTokenSilently,
      outgoingMessage,
    });
    if (expandedRowsContext) {
      // CHECKS to see if the EDIT PANEL is coming from the action summary mid trade. If so, it will return the back to the trade once updating the CPs.
      onNodeCollapseChangeAllSettingsToFalse(
        expandedRowsContext,
        setExpandedRowsContext,
        data.esid,
        setExpandedRowsContextMostRecentlyUpdated,
      );
    }
  }

  // Return the main button actions:
  const getActions = (structureType: string, status: string) => {
    const keyToPass = getEnumKeyByEnumValue(ExecutionStrategyStatus, status); // Reverse map the string back to the enum.
    if (keyToPass) {
      return actionsConfigOP[structureType]?.[keyToPass] || [];
    }
  };

  return (
    <div>
      {data.status != "New" ? (
        <Button
          variant="mainBlueAction"
          size={dynamicButtonSize}
          onClick={() => updatePanelAction()}
          id="updatePanel"
        >
          Update
        </Button>
      ) : (
        <div>
          {getActions("NotSent", "SelectPanel").map(
            (action: IActionObj, index: number) => (
              <div className="" key={index}>
                <Button
                  variant={
                    index == 0 ? "mainOrangeAction" : "secondaryBlueAction"
                  }
                  size={dynamicButtonSize}
                  id={action.id.toString().replace(/\s+/g, "")}
                  onClick={() => {
                    // send a different argument if sending to panel (which happens at index 0) - does not send data.
                    if (index == 0) {
                      action.function({
                        outgoingTradeMessage: generateOutgoingTradeMessage(
                          data.esid,
                          data.notationES,
                        ),
                        getAccessTokenSilently: getAccessTokenSilently,
                      });
                    } else {
                      action.function({
                        data: data,
                        getAccessTokenSilently: getAccessTokenSilently,
                      });
                    }
                  }}
                  onDoubleClick={(e) => e.stopPropagation()}
                >
                  {action.id}
                </Button>
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default MainButtonActionSelectPanel;
